import dayjs from "dayjs";

const $date = dayjs;
export default $date;
